import React from "react";

// Subtle India outline – simplified for background usage. Not geographically perfect,
// just enough to suggest "India / national scale" behind copy.
export default function IndiaMap({ className = "", color = "#3AB0FF", opacity = 0.12 }) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={className}
      aria-hidden="true"
      style={{ opacity }}
      fill={color}
    >
      <path d="M340 50c-8 6-16 12-22 22-7 13-9 22-13 35-2 8-8 18-15 22-7 5-21 9-26 9-10 0-25-6-37-3-7 2-20 10-26 16-6 5-9 14-13 22-3 5-11 8-13 14-3 8 4 14 9 19s17 9 23 16 7 16 6 25c-2 12-12 24-22 30-10 7-20 13-27 23-7 11-3 21-2 33 1 13-4 27-12 38-7 9-19 16-22 28-3 11 3 22 8 32 4 9 9 17 16 24 6 6 17 8 21 16 5 9 1 22 4 32 2 9 9 17 16 22 8 6 18 8 27 12 7 3 12 9 19 12 8 4 18 4 26 1 9-4 11-13 16-21 4-8 12-12 21-13 9-2 19 1 27 6 9 5 13 16 22 22 11 7 24 4 35 1 9-2 15-12 24-15 8-2 18 1 26-3 9-5 13-15 16-25 3-9 5-19 11-26 7-7 17-9 23-16 8-9 8-23 12-34 4-13 16-23 22-35 4-9 4-21 11-28 6-7 16-7 22-14 8-9 8-23 11-34 3-13 11-23 16-35 6-13 10-27 16-40 5-12 12-22 16-34 4-13 3-27 1-40-2-12-8-23-11-35-2-10-1-21-6-30-6-12-21-15-32-19-13-4-25-13-38-15-13-3-26 4-39 4-13 0-26-6-39-5-9 0-17 6-25 11-9 5-17 14-26 17-10 3-23-1-32 3-9 4-13 16-21 22z" />
    </svg>
  );
}
